import type {MailAttachment} from "@t/mail/MailAttachment";

/** Used to apply template */
export interface TemplateVariables {
	[key: string]: string | number | MailAttachment[];
}

export interface ApplyTemplateResponse {
	output: string;
	contentType: string;
	properties?: TemplateVariables;
}

// DESCRIPTOR_TASK -> TASK
export const TemplateType = {
	TASK: 1,
	EVENT: 2,
	EMAIL: 3,
	OPPORTUNITY: 4,
	BUSCASE: 5,
	CONTACT: 6,
	PARTY: 7,
	PROBLEM: 9,
	USER: 10,
	INVOICE: 11,
	PRODUCT: 12,
	OFFER: 14,
	STORE: 17,
	MOTION: 18,
	BONUS: 19,
	COMPOSE_EMAIL: 20,
	TRANSFER: 22,
	EMAIL_STYLE: 23,
	SMS: 24,
	PATTERN_TASK: 101,
	PATTERN_EVENT: 102,
	PATTERN_CONTACT: 106,
} as const;